// @flow
import { toDanishCurrencyString } from './util';

import { apiBase } from '../config';

// Shapes the raw fetchPropertyByCaseNo payload *in place*: ranks improvements by
// descending green value, orders the profitable ones first, and prepends a
// synthetic "Alle" tab that aggregates the profitable set — or, when nothing is
// profitable, the renovation set with alternate wording. Returns the payload
// untouched when it carries no `profilt` array or an empty one.
export const shapePropertyResponse = (result: any) => {
  const _all = {
    id: -1,
    title: 'Alle',
    ShortText: '',
    LongText: '',
    profitable: 'true',
    Investment: 0,
    MoneySaving: 0,
    CO2Saving: 0,
    _greenImprovementValue: 100,
    _isAllTab: true,
  };

  if (result && Array.isArray(result.profilt) && result.profilt.length > 0) {
    let profitableProfilt = result.profilt.filter(
      data => data.profitable === 'true'
    );

    let nonProfitableProfilt = result.profilt.filter(
      data => data.profitable === 'false'
    );

    const reduceProfilt =
      profitableProfilt.length > 0 ? profitableProfilt : nonProfitableProfilt;

    const total = reduceProfilt.reduce((currentTotal, improvement) => {
      const addValue = parseInt(improvement.CO2Saving * 100, 10);

      _all.Investment += parseInt(improvement.Investment, 10);
      _all.MoneySaving += parseInt(improvement.MoneySaving, 10);
      _all.CO2Saving += parseFloat(improvement.CO2Saving);

      return currentTotal + addValue;
    }, 0);

    result.profilt = result.profilt
      .map(improvement => {
        const calculatedImprovement = {
          ...improvement,
          _greenImprovementValue: Math.round(
            (parseInt(improvement.CO2Saving * 100, 10) * 100) / total
          ),
        };
        return calculatedImprovement;
      })
      .sort(
        (a, b) => b._greenImprovementValue - a._greenImprovementValue
      );

    profitableProfilt = result.profilt.filter(
      data => data.profitable === 'true'
    );
    nonProfitableProfilt = result.profilt.filter(
      data => data.profitable === 'false'
    );

    result.profilt = [...profitableProfilt, ...nonProfitableProfilt];

    const noProfitable = profitableProfilt.length === 0;

    _all.profitable = noProfitable ? 'false' : 'true';

    _all.ShortText = noProfitable
      ? 'Alle rentable forbedringer ved renovering'
      : 'Alle rentable forbedringer';

    const alleInitialText = noProfitable
      ? 'Udføres alle renoveringer, vil det give en årlig besparelse på '
      : `Udføres alle de rentable forbedringsforslag, vil det koste <b>${toDanishCurrencyString(
          _all.Investment,
          0
        )} kr.</b> og give en årlig besparelse på `;

    _all.LongText = `${alleInitialText}<b>${toDanishCurrencyString(
      _all.MoneySaving,
      0
    )} kr.</b> og <b>${toDanishCurrencyString(
      _all.CO2Saving,
      2
    )} ton CO2.</b>`;

    result.profilt.unshift(_all);
  }

  return result;
};

export const getLocationDetailsByCaseNumber = (caseNumber: string) => {
  return fetch(`${apiBase}/v1/fetchPropertyByCaseNo`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      caseNumber,
    }),
  })
    .then(response => response.json())
    .then(response => shapePropertyResponse(response.response));
};
